// Firebase refs
export const PENDING_USERS_REF = 'PendingUsers';
export const USERS_REF = 'Users';
export const ADMINS_REF = 'Admins';
export const ALLOWED_USERS_REF = 'AllowedUsers';

export const ANALYSIS_JOB_REF = 'TSS-Config/analysis_job_on';
export const SEND_DAILY_REPORT_EMAIL_REF = 'TSS-Config/send_daily_report_email';
export const DAILY_REPORT_EMAIL_OFF = 'off';
export const DAILY_REPORT_EMAIL_TIMES = (() => {
  const times = [DAILY_REPORT_EMAIL_OFF];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      times.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
    }
  }
  return times;
})();

export function formatTimeLabel(hhmm) {
  if (!hhmm || hhmm === DAILY_REPORT_EMAIL_OFF) return 'Off';
  const [hStr, mStr] = hhmm.split(':');
  const h = parseInt(hStr, 10);
  const m = parseInt(mStr, 10) || 0;
  const period = h < 12 ? 'AM' : 'PM';
  const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${h12}:${String(m).padStart(2, '0')} ${period}`;
}

export const SEND_URGENT_TELEGRAM_NOTIFICATION_REF = 'TSS-Config/send_urgent_telegram_notification';
export const URGENT_TELEGRAM_OFF = 'off';
export const URGENT_TELEGRAM_SCORES = (() => {
  const options = [URGENT_TELEGRAM_OFF];
  for (let i = 100; i >= 0; i--) options.push(String(i));
  return options;
})();

export const ANALYZE_WATCHLISTS_REF = 'TSS-Config/analyze_watchlists';
export const WATCHLIST_EXCHANGES_REF = 'TSS-Config/watchlist_exchanges';
export const WATCHLIST_DISABLED = 'DISABLED';

export const EXCHANGE_OPTIONS = [
  { code: 'US', label: 'US (NYSE / NASDAQ)' },
  { code: 'LON', label: 'LON (London Stock Exchange)' },
  { code: 'TRT', label: 'TRT (Toronto Stock Exchange)' },
  { code: 'TRV', label: 'TRV (Toronto Venture Exchange)' },
  { code: 'DEX', label: 'DEX (XETRA — Germany)' },
  { code: 'BSE', label: 'BSE (Bombay Stock Exchange — India)' },
  { code: 'NSE', label: 'NSE (National Stock Exchange — India)' },
  { code: 'SHH', label: 'SHH (Shanghai Stock Exchange)' },
  { code: 'SHZ', label: 'SHZ (Shenzhen Stock Exchange)' },
  { code: 'SI', label: 'SI (Singapore Exchange)' },
];

export const ANALYZE_NUM_OF_STOCKS_REF = 'TSS-Config/analyze_num_of_stocks';
export const ANALYSIS_API_REF = 'TSS-Config/analysis_api';
export const ANALYSIS_API_MASSIVE = 'massive';
export const ANALYSIS_API_ALPHAVANTAGE = 'alphavantage';
export const ANALYSIS_API_OPTIONS = [
  { value: ANALYSIS_API_MASSIVE, label: 'Massive' },
  { value: ANALYSIS_API_ALPHAVANTAGE, label: 'Alpha Vantage' },
];
export const DATA_FRESHNESS_HOURS_REF = 'TSS-Config/data_freshness_hours';
export const REPORT_SIZE_REF = 'TSS-Config/report_size';
export const SYSTEM_MAINTENANCE_REF = 'TSS-Config/system_maintenance';
export const FRESHNESS_HOURS_OPTIONS = [...Array.from({ length: 24 }, (_, i) => i + 1), 30, 36, 42, 48];
export const REPORT_SIZE_OPTIONS = Array.from({ length: 25 }, (_, i) => i + 1);

export const ANALYSIS_REF = 'TSS-Analysis';
export const REPORT_PUBLISH_REF = 'TSS-Report-Publish';
export const REPORT_WORKSPACE_REF = 'TSS-Report-Workspace';
export const WATCHLIST_REF = 'TSS-Watchlist';
export const WATCHLIST_TIMESTAMP_KEYS = ['timestamp', 'lastAnalyzed', 'last_analyzed', 'analyzedAt', 'time', 'lastUpdated'];

export function stripTimestampsFromWatchlist(data) {
  if (!data || typeof data !== 'object') return data;
  const out = {};
  for (const watchlist of Object.keys(data)) {
    const watchlistData = data[watchlist];
    if (!watchlistData || typeof watchlistData !== 'object') {
      out[watchlist] = watchlistData;
      continue;
    }
    out[watchlist] = {};
    for (const ticker of Object.keys(watchlistData)) {
      const item = watchlistData[ticker];
      if (!item || typeof item !== 'object') {
        out[watchlist][ticker] = item;
        continue;
      }
      const { ...rest } = item;
      WATCHLIST_TIMESTAMP_KEYS.forEach((k) => delete rest[k]);
      out[watchlist][ticker] = rest;
    }
  }
  return out;
}
